import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AccountCreationModal from 'modules/expenses/components/common/AccountCreationModal'
import { CtaDescription } from 'modules/expenses/components/common/CardsHero'
import type { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'

import SkipProcessModal from './SkipProcessModal'

type CardsBannerProps = {
  onDismiss: () => void
}

const CardsBanner = ({ onDismiss }: CardsBannerProps) => {
  const { onboarding } = useOutletContext<RouteContextParams>()
  const [isAccountCreationModalOpen, setIsAccountCreationModalOpen] = React.useState(false)
  const [isSkipConfirmationModalOpen, setIsSkipConfirmationModalOpen] = React.useState(false)

  const onGetCards = () => {
    setIsAccountCreationModalOpen(true)
  }

  const onNotNowButtonClick = () => {
    setIsSkipConfirmationModalOpen(true)
    track(trackingEvents.expenses.viewSkipProcessModal)
  }

  const onSkipConfirm = () => {
    setIsSkipConfirmationModalOpen(false)
    onDismiss()
  }

  const onSkipProcessModalNoButtonClick = () => {
    track(trackingEvents.expenses.cancelSkipCardsBanner)
  }

  const onSkipProcessModalClose = () => {
    setIsSkipConfirmationModalOpen(false)
    if (onSkipProcessModalNoButtonClick) {
      onSkipProcessModalNoButtonClick()
    }
  }

  useEffect(() => {
    track(trackingEvents.expenses.viewSkippableCardsBanner)
  }, [])

  const ctaDescription = onboarding
    ? CtaDescription.COMPLETE_ACCOUNT
    : CtaDescription.CREATE_ACCOUNT

  const primaryButtonText = onboarding
    ? i18n.t('expenses_v2.cards.blocks.require_onboarding.complete_account')
    : i18n.t('expenses_v2.cards.blocks.require_onboarding.create_account')

  const showCompleteCardsCta = ctaDescription === CtaDescription.COMPLETE_ACCOUNT

  return (
    <Box width="full" paddingBottom="s24">
      <Callout
        description={
          showCompleteCardsCta
            ? i18n.t('expenses_v2.cards.blocks.hero_section.account_creation_subtitle.incomplete')
            : i18n.t('expenses_v2.cards.blocks.hero_section.account_creation_subtitle.not_started')
        }
        type="warning"
        hideIcon={false}
        onRemove={onNotNowButtonClick}
        action={
          <Button type="secondary" onClick={onGetCards}>
            {primaryButtonText}
          </Button>
        }
        compact
      />
      {isAccountCreationModalOpen && (
        <AccountCreationModal
          source="expenses"
          trackingEvent={trackingEvents.expenses.goToCreateCardsAccountFromCardsBanner}
          onClose={() => {
            setIsAccountCreationModalOpen(false)
          }}
        />
      )}
      {isSkipConfirmationModalOpen && (
        <SkipProcessModal onClose={onSkipProcessModalClose} onConfirm={onSkipConfirm} />
      )}
    </Box>
  )
}

export default CardsBanner
